<template>
  <div class="container-lg">
    <div v-if="product.published_reviews.length">
      <div class="tabs__nav-item active">

        {{ in18['page_product_reviews'] }}
      </div>
      <section class="mt-4">
        <div v-for="review in this.product.published_reviews" :key="review.id">
          <div class="reviews__item">
            <div class="rating-info d-flex">
              <div class="star-rating d-flex align-items-center">
                <star-rating :rate="review.rate"></star-rating>
              </div>
              <div class="review__header align-items-center">
                <span class="reviews__name text-primary ml-9">
                  {{ review.user_name }}
                </span>
                <span class="ml-9 text-gray-600">
                  {{ formatDate(review.updated_at) }}
                </span>
              </div>
            </div>
            <div class="text mt-3">
              {{ review.comment }}
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import StarRating from "../form-field/StarRating.vue";

export default {
  name:       'ProductReviews',
  components: {
    'star-rating': StarRating,
  },
  props:      {
    product: Object,
    in18:    {
      type: Object,
    },
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>